import '../App.css';
import React, { useEffect, useState } from "react";
import Nav from '../components/Nav.js';
import Footer from '../components/Footer.js';

// Motoway'de üyelik e-postasındaki onay bağlantısı (Supabase Auth) buraya döner.
// Başarılı onayda adres çubuğunda oturum belirteçleri gelir; sayfa bunları hemen adresten siler
// ve kullanmaz. Üye uygulamaya dönüp e-posta ve parolasıyla giriş yapar.
const MotowayEmailConfirmed = () => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const params = new URLSearchParams(window.location.hash.slice(1) || window.location.search);
    setFailed(params.has('error') || params.has('error_code'));
    if (window.location.hash || window.location.search) {
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);

  return (
    <>
      <Nav minimal />
      <main className="privacy-page" lang="tr">
        <span className="eyebrow"><span className="dot" /> Motoway</span>
        {failed ? (
          <>
            <h1>Bağlantı geçersiz</h1>
            <p>
              Bu onay bağlantısının süresi dolmuş ya da daha önce kullanılmış. Motoway uygulamasında
              e-posta ve parolanla giriş yapmayı dene; e-postan henüz onaylanmadıysa yeniden üye
              olarak yeni bir onay bağlantısı isteyebilirsin.
            </p>
          </>
        ) : (
          <>
            <h1>E-postan onaylandı</h1>
            <p>
              Teşekkürler! Motoway hesabın hazır. Uygulamaya dönüp e-posta adresin ve parolanla
              giriş yapabilirsin.
            </p>
          </>
        )}
        <p>
          <a className="btn" href="motoway://auth">Motoway'i aç</a>
        </p>
        <p>
          Sorun yaşarsan bize yaz: <a href="mailto:app@meck-int.com">app@meck-int.com</a>
        </p>
      </main>
      <Footer />
    </>
  );
};

export default MotowayEmailConfirmed;
